var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "px-4" }, [
      _c(
        "div",
        {
          staticClass:
            "shadow bg-white px-4 py-12 rounded-lg relative overflow-hidden print-padding",
        },
        [
          _c(
            "div",
            { staticClass: "max-w-3xl m-auto mb-16" },
            [
              _c("InvoiceHeader", {
                attrs: { message: "Submit an invoice" },
                on: { back: _vm.handleBack, close: _vm.handleClose },
              }),
            ],
            1
          ),
          _c("StepProgress", {
            attrs: { steps: _vm.steps, activeStep: _vm.activeStep },
          }),
          _c(
            "div",
            [
              _vm.activeStep === 0
                ? _c("Step1", {
                    attrs: {
                      currentUser: _vm.currentUser,
                      record: _vm.inoviceRecord,
                    },
                    on: { continue: _vm.goToNextStep },
                  })
                : _vm.activeStep === 1
                ? _c("Step2", {
                    attrs: {
                      currentUser: _vm.currentUser,
                      record: _vm.inoviceRecord,
                    },
                    on: { continue: _vm.goToNextStep },
                  })
                : _vm.activeStep === 2
                ? _c("Step3", {
                    attrs: {
                      currentUser: _vm.currentUser,
                      record: _vm.inoviceRecord,
                    },
                    on: {
                      continue: _vm.goToNextStep,
                      editStepper: _vm.gotoStep,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }